import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {PageContentPreviewable} from 'shells/layout/page-content-previewable/page-content-previewable';

import type {DigestTypeEnum} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {PageTitleBar} from '../../layout';

import {DigestPreviewHeader} from './digest-preview-header';
import {DigestsConfig} from './digests-config';
import {useGetDigestConfiguration} from './graphql/hooks/use-get-digest-configuration';
import {useGetDigestPreview} from './graphql/hooks/use-get-digest-preview';

import styles from './email-digests-config-page.module.css';

export function EmailDigestsConfigPage() {
    const {user} = useGetSessionUser();
    const isAdmin = user ? user.isAdministrator : false;

    const [selectedPreviewType, setSelectedPreviewType] =
        React.useState<DigestTypeEnum>('MORNING_DIGEST');

    const {isLoading: isLoadingMorningJolt, configuration: morningJoltConfiguration} =
        useGetDigestConfiguration('MORNING_DIGEST');
    const {isLoading: isLoadingTeamReport, configuration: teamReportConfiguration} =
        useGetDigestConfiguration('TEAM_REPORT');

    const {isLoading: isLoadingMorningJoltPreview, preview: morningJoltPreview} =
        useGetDigestPreview('MORNING_DIGEST');
    const {isLoading: isLoadingTeamReportPreview, preview: teamReportPreview} =
        useGetDigestPreview('TEAM_REPORT');

    const morningJoltSubscription = morningJoltConfiguration
        ? morningJoltConfiguration.subscription
        : null;
    const teamReportSubscription = teamReportConfiguration
        ? teamReportConfiguration.subscription
        : null;

    const morningJoltNextSendDate = morningJoltConfiguration
        ? morningJoltConfiguration.nextSendDate
        : null;
    const teamReportNextSendDate = teamReportConfiguration
        ? teamReportConfiguration.nextSendDate
        : null;

    const morningJoltPreviewHtml = morningJoltPreview ? morningJoltPreview.previewHtml : null;
    const teamReportPreviewHtml = teamReportPreview ? teamReportPreview.previewHtml : null;

    const previewHtml =
        selectedPreviewType === 'MORNING_DIGEST' ? morningJoltPreviewHtml : teamReportPreviewHtml;

    return (
        <>
            <PageTitleBar
                title='Email digests'
                subheaderPrimaryText='Automated summaries that keep you informed on sales activity and performance'
            />
            <PageContentPreviewable
                isScrollable={true}
                previewBackgroundColor={colors.offWhiteDk}
                previewLabel=''
                upperContent={
                    <DigestPreviewHeader
                        selectedPreviewType={selectedPreviewType}
                        setSelectedPreviewType={setSelectedPreviewType}
                        isAdmin={isAdmin}
                    />
                }
                leftContent={
                    <DigestsConfig
                        morningJoltSubscription={morningJoltSubscription}
                        isLoadingMorningJolt={isLoadingMorningJolt}
                        teamReportSubscription={teamReportSubscription}
                        isLoadingTeamReport={isLoadingTeamReport}
                        morningJoltNextSendDate={morningJoltNextSendDate}
                        teamReportNextSendDate={teamReportNextSendDate}
                        isAdmin={isAdmin}
                    />
                }
                // @ts-expect-error
                getPreview={() => {
                    if (
                        (!morningJoltPreviewHtml && isLoadingMorningJoltPreview) ||
                        (!teamReportPreviewHtml && isLoadingTeamReportPreview)
                    ) {
                        return (
                            <div className='absolutely-center-and-fill'>
                                <LoadingIcon fill={colors.orange} />
                            </div>
                        );
                    }

                    if (!previewHtml) {
                        return null;
                    }

                    return (
                        <iframe
                            srcDoc={previewHtml}
                            title='Email digest preview'
                            sandbox='allow-same-origin allow-scripts'
                            className={styles['preview-iframe']}
                        />
                    );
                }}
            />
        </>
    );
}
